import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addAllParticipantRequest = {};
var _addAllParticipantResponse = {};
var _addParticipantRequest = {};
var _addParticipantResponse = { participant: '_participant' };
var _addParticipantsRequest = {};
var _addParticipantsResponse = { participants: '_participant' };
var _applyCouponToOrderRequest = {};
var _applyCouponToOrderResponse = {};
var _certificate = { issuedDate: 'google.protobuf.Timestamp' };
var _challengeSection = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    settings: '_settings',
    steps: '_challengeStep',
};
var _challengeStep = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    settings: '_challengeStepSettings',
};
var _challengeStepSettings = { general: '_generalSettings' };
var _choice = { description: '_objectDescription' };
var _createJoinRequestRequest = {};
var _createJoinRequestResponse = { participant: '_participant' };
var _createPaymentOrderRequest = {};
var _createPaymentOrderResponse = { participant: '_participant' };
var _deleteParticipantRequest = {};
var _deleteParticipantResponse = {};
var _document = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _entitySummary = { media: '_mediaItem' };
var _feedback = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    items: '_feedbackItem',
    quiz: '_feedbackItem',
};
var _feedbackItem = { media: '_mediaItems', quantity: '_quantity' };
var _feedbackItemSettings = { type: '_feedbackItemType' };
var _feedbackItemType = {
    multipleChoice: '_multipleChoiceFeedbackItem',
    quantity: '_quantityFeedbackItem',
    multiSelect: '_multipleChoiceFeedbackItem',
};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _generalSettings = {
    individual: '_individualSettings',
    video: '_videoStepSettings',
    description: '_objectDescription',
};
var _getCertificateRequest = {};
var _getCertificateResponse = {};
var _getMediaUploadInfoRequest = {};
var _getMediaUploadInfoResponse = {};
var _getParticipantRequest = {};
var _getParticipantResponse = { participant: '_participant' };
var _getParticipantSectionRequest = {};
var _getParticipantSectionResponse = { section: '_participantSection' };
var _getParticipantStepRequest = { timeInterval: '_timeInterval' };
var _getParticipantStepResponse = {
    step: '_participantStep',
    subSteps: '_participantStep',
};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _individualSettings = {
    feedbackSettings: '_feedbackItemSettings',
    quizSettings: '_feedbackItemSettings',
};
var _inviteAllParticipantsRequest = {};
var _inviteAllParticipantsResponse = {};
var _inviteParticipantsRequest = {};
var _inviteParticipantsResponse = {};
var _issueCertificateRequest = {};
var _issueCertificateResponse = { participant: '_participant' };
var _issueParticipantCertificateRequest = {};
var _issueParticipantCertificateResponse = { participant: '_participant' };
var _joinParticipantRequest = {};
var _joinParticipantResponse = { participant: '_participant' };
var _listParticipantSectionsRequest = {};
var _listParticipantSectionsResponse = { sections: '_participantSection' };
var _listParticipantsRequest = {};
var _listParticipantsResponse = { participants: '_participant' };
var _listParticipantStepsRequest = { timeInterval: '_timeInterval' };
var _listParticipantStepsResponse = { steps: '_participantStep' };
var _mediaItem = { image: '_image', video: '_video', document: '_document' };
var _mediaItems = { mediaItems: '_mediaItem' };
var _multipleChoiceFeedbackItem = { choices: '_choice' };
var _myProgramRequest = {};
var _myProgramResponse = { participant: '_participant' };
var _myProgramSectionRequest = {};
var _myProgramSectionResponse = { participantSection: '_participantSection' };
var _myProgramStepRequest = {};
var _myProgramStepResponse = { participantStep: '_participantStep' };
var _objectDescription = { media: '_mediaItem' };
var _participant = {
    performance: 'DOUBLE',
    challenge: '_entitySummary',
    timeFrame: '_timeInterval',
    stepsSummary: '_stepsSummary',
    transitions: '_stateTransition',
    certificate: '_certificate',
};
var _participantSection = {
    source: '_challengeSection',
    steps: '_participantStep',
    transitions: '_participantSectionStateTransition',
};
var _participantSectionStateTransition = {
    occurredAt: 'google.protobuf.Timestamp',
};
var _participantStep = {
    source: '_challengeStep',
    timeFrame: '_timeInterval',
    feedback: '_feedback',
    transitions: '_participantStepStateTransition',
    quizSubmission: '_quizSubmission',
};
var _participantStepStateTransition = {
    occurredAt: 'google.protobuf.Timestamp',
};
var _quantity = { amount: 'DOUBLE' };
var _quantityFeedbackItem = { amount: 'DOUBLE' };
var _queryParticipantsRequest = {};
var _queryParticipantsResponse = { participants: '_participant' };
var _quizSubmission = { score: 'google.protobuf.DoubleValue' };
var _removeCouponFromOrderRequest = {};
var _removeCouponFromOrderResponse = {};
var _resetParticipantProgressRequest = {};
var _resetParticipantProgressResponse = { participant: '_participant' };
var _resolveParticipantStepRequest = { feedback: '_feedback' };
var _resolveParticipantStepResponse = { step: '_participantStep' };
var _reviveParticipantRequest = {};
var _reviveParticipantResponse = { participant: '_participant' };
var _settings = { description: '_objectDescription' };
var _stateTransition = { occurredAt: 'google.protobuf.Timestamp' };
var _stepEvent = { transition: '_participantStepStateTransition' };
var _stepsSummary = { lastEvent: '_stepEvent' };
var _timeInterval = {
    start: 'google.protobuf.Timestamp',
    finish: 'google.protobuf.Timestamp',
};
var _updateParticipantRequest = {};
var _updateParticipantResponse = { participant: '_participant' };
var _updateStepFeedbackRequest = { feedback: '_feedback' };
var _updateStepFeedbackResponse = { step: '_participantStep' };
var _video = { thumbnail: '_image' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoStepSettings = {
    requiredCompletionPercentage: 'DOUBLE',
    video: '_videoV2',
    coverImage: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveComWixpressAchievementsApiV1ParticipantsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/challenges/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        _: [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/challenges/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'challenges.wixapps.net': [
            {
                srcPath: '/challenge-service-web/api',
                destPath: '',
            },
            {
                srcPath: '/challenge-service-web/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/v1',
                destPath: '/api/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/challenge-service-web/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/challenge-service-web',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function queryParticipants(payload) {
    var _a = serializer(_queryParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryParticipantsResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __queryParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.QueryParticipants',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryParticipants.fromReq = fromReq;
    __queryParticipants.__isAmbassador = true;
    return __queryParticipants;
}
/** @deprecated */
export function listParticipants(payload) {
    var _a = serializer(_listParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listParticipantsResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __listParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.ListParticipants',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __listParticipants.fromReq = fromReq;
    __listParticipants.__isAmbassador = true;
    return __listParticipants;
}
export function joinParticipant(payload) {
    var _a = serializer(_joinParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_joinParticipantResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __joinParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.JoinParticipant',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __joinParticipant.fromReq = fromReq;
    __joinParticipant.__isAmbassador = true;
    return __joinParticipant;
}
/** owner adds participant to the challenge */
export function addParticipant(payload) {
    var _a = serializer(_addParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addParticipantResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __addParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.AddParticipant',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addParticipant.fromReq = fromReq;
    __addParticipant.__isAmbassador = true;
    return __addParticipant;
}
/** owner adds participants to the challenge */
export function addParticipants(payload) {
    var _a = serializer(_addParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addParticipantsResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __addParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.AddParticipants',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/bulk-add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addParticipants.fromReq = fromReq;
    __addParticipants.__isAmbassador = true;
    return __addParticipants;
}
export function addAllParticipant(payload) {
    var _a = serializer(_addAllParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addAllParticipantResponse, {}).fromJSON;
    function __addAllParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.AddAllParticipant',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/add-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addAllParticipant.fromReq = fromReq;
    __addAllParticipant.__isAmbassador = true;
    return __addAllParticipant;
}
export function createJoinRequest(payload) {
    var _a = serializer(_createJoinRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createJoinRequestResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __createJoinRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.CreateJoinRequest',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/join-requests',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createJoinRequest.fromReq = fromReq;
    __createJoinRequest.__isAmbassador = true;
    return __createJoinRequest;
}
export function inviteParticipants(payload) {
    var _a = serializer(_inviteParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_inviteParticipantsResponse, {}).fromJSON;
    function __inviteParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.InviteParticipants',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/invitations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __inviteParticipants.fromReq = fromReq;
    __inviteParticipants.__isAmbassador = true;
    return __inviteParticipants;
}
export function inviteAllParticipants(payload) {
    var _a = serializer(_inviteAllParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_inviteAllParticipantsResponse, {}).fromJSON;
    function __inviteAllParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.InviteAllParticipants',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/invite-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __inviteAllParticipants.fromReq = fromReq;
    __inviteAllParticipants.__isAmbassador = true;
    return __inviteAllParticipants;
}
/** returns participant by id */
export function getParticipant(payload) {
    var _a = serializer(_getParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getParticipantResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __getParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.GetParticipant',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}/{participantId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getParticipant.fromReq = fromReq;
    __getParticipant.__isAmbassador = true;
    return __getParticipant;
}
export function updateParticipant(payload) {
    var _a = serializer(_updateParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateParticipantResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __updateParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'PATCH',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.UpdateParticipant',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/{participantId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateParticipant.fromReq = fromReq;
    __updateParticipant.__isAmbassador = true;
    return __updateParticipant;
}
/** by owner - makes participant REMOVED. By participant himself - LEFT. */
export function deleteParticipant(payload) {
    var _a = serializer(_deleteParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteParticipantResponse, {}).fromJSON;
    function __deleteParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'DELETE',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.DeleteParticipant',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteParticipant.fromReq = fromReq;
    __deleteParticipant.__isAmbassador = true;
    return __deleteParticipant;
}
export function reviveParticipant(payload) {
    var _a = serializer(_reviveParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reviveParticipantResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __reviveParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'PATCH',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.ReviveParticipant',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/revive/{participantId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reviveParticipant.fromReq = fromReq;
    __reviveParticipant.__isAmbassador = true;
    return __reviveParticipant;
}
export function resetParticipantProgress(payload) {
    var _a = serializer(_resetParticipantProgressRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resetParticipantProgressResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __resetParticipantProgress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'PATCH',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.ResetParticipantProgress',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/reset/{participantId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resetParticipantProgress.fromReq = fromReq;
    __resetParticipantProgress.__isAmbassador = true;
    return __resetParticipantProgress;
}
export function issueParticipantCertificate(payload) {
    var _a = serializer(_issueParticipantCertificateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_issueParticipantCertificateResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __issueParticipantCertificate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.IssueParticipantCertificate',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/issue_certificate/{participantId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __issueParticipantCertificate.fromReq = fromReq;
    __issueParticipantCertificate.__isAmbassador = true;
    return __issueParticipantCertificate;
}
export function issueCertificate(payload) {
    var _a = serializer(_issueCertificateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_issueCertificateResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __issueCertificate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.IssueCertificate',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/get_certificate/{participantId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __issueCertificate.fromReq = fromReq;
    __issueCertificate.__isAmbassador = true;
    return __issueCertificate;
}
export function getCertificate(payload) {
    var _a = serializer(_getCertificateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCertificateResponse, {}).fromJSON;
    function __getCertificate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.GetCertificate',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/certificate/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}/certificate/{participantId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getCertificate.fromReq = fromReq;
    __getCertificate.__isAmbassador = true;
    return __getCertificate;
}
export function createPaymentOrder(payload) {
    var _a = serializer(_createPaymentOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPaymentOrderResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __createPaymentOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.CreatePaymentOrder',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/payment-orders/{participantId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPaymentOrder.fromReq = fromReq;
    __createPaymentOrder.__isAmbassador = true;
    return __createPaymentOrder;
}
/** ---------------------------------------------------- Coupons ----------------------------------------------------- */
export function applyCouponToOrder(payload) {
    var _a = serializer(_applyCouponToOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_applyCouponToOrderResponse, {}).fromJSON;
    function __applyCouponToOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.ApplyCouponToOrder',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/payment-orders/{participantId}/coupons/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __applyCouponToOrder.fromReq = fromReq;
    __applyCouponToOrder.__isAmbassador = true;
    return __applyCouponToOrder;
}
export function removeCouponFromOrder(payload) {
    var _a = serializer(_removeCouponFromOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeCouponFromOrderResponse, {}).fromJSON;
    function __removeCouponFromOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'DELETE',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.RemoveCouponFromOrder',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/payment-orders/{participantId}/coupons/{orderId}/{couponId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeCouponFromOrder.fromReq = fromReq;
    __removeCouponFromOrder.__isAmbassador = true;
    return __removeCouponFromOrder;
}
export function listSteps(payload) {
    var _a = serializer(_listParticipantStepsRequest, { _timeInterval: _timeInterval }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listParticipantStepsResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.ListSteps',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/steps/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}/steps/{participantId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __listSteps.fromReq = fromReq;
    __listSteps.__isAmbassador = true;
    return __listSteps;
}
export function getStep(payload) {
    var _a = serializer(_getParticipantStepRequest, { _timeInterval: _timeInterval }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getParticipantStepResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.GetStep',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/steps/{participantId}/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}/steps/{participantId}/{stepId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getStep.fromReq = fromReq;
    __getStep.__isAmbassador = true;
    return __getStep;
}
export function resolveStep(payload) {
    var _a = serializer(_resolveParticipantStepRequest, {
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _quantity: _quantity,
        _video: _video,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveParticipantStepResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __resolveStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'PATCH',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.ResolveStep',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/steps/{participantId}/{stepId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveStep.fromReq = fromReq;
    __resolveStep.__isAmbassador = true;
    return __resolveStep;
}
export function updateStepFeedback(payload) {
    var _a = serializer(_updateStepFeedbackRequest, {
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _quantity: _quantity,
        _video: _video,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStepFeedbackResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateStepFeedback(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'PUT',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.UpdateStepFeedback',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/steps/{participantId}/feedback/{stepId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStepFeedback.fromReq = fromReq;
    __updateStepFeedback.__isAmbassador = true;
    return __updateStepFeedback;
}
export function getMediaUploadInfo(payload) {
    var _a = serializer(_getMediaUploadInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMediaUploadInfoResponse, {}).fromJSON;
    function __getMediaUploadInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.GetMediaUploadInfo',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/media/upload_info/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}/media/upload_info/{participantId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getMediaUploadInfo.fromReq = fromReq;
    __getMediaUploadInfo.__isAmbassador = true;
    return __getMediaUploadInfo;
}
/** ---------------------------------------------------- Sections -------------------------------------------------------- */
export function listSections(payload) {
    var _a = serializer(_listParticipantSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listParticipantSectionsResponse, {
        _challengeSection: _challengeSection,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantSection: _participantSection,
        _participantSectionStateTransition: _participantSectionStateTransition,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _settings: _settings,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.ListSections',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/sections/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}/sections/{participantId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __listSections.fromReq = fromReq;
    __listSections.__isAmbassador = true;
    return __listSections;
}
export function getSection(payload) {
    var _a = serializer(_getParticipantSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getParticipantSectionResponse, {
        _challengeSection: _challengeSection,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantSection: _participantSection,
        _participantSectionStateTransition: _participantSectionStateTransition,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _settings: _settings,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.GetSection',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/{challengeId}/sections/{participantId}/{sectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/{challengeId}/sections/{participantId}/{sectionId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getSection.fromReq = fromReq;
    __getSection.__isAmbassador = true;
    return __getSection;
}
export function myProgram(payload) {
    var _a = serializer(_myProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_myProgramResponse, {
        _certificate: _certificate,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _participant: _participant,
        _participantStepStateTransition: _participantStepStateTransition,
        _stateTransition: _stateTransition,
        _stepEvent: _stepEvent,
        _stepsSummary: _stepsSummary,
        _timeInterval: _timeInterval,
        _video: _video,
    }).fromJSON;
    function __myProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.MyProgram',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/my_program/{programId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/my_program/{programId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __myProgram.fromReq = fromReq;
    __myProgram.__isAmbassador = true;
    return __myProgram;
}
export function myProgramStep(payload) {
    var _a = serializer(_myProgramStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_myProgramStepResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __myProgramStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.MyProgramStep',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/my_program/{programId}/step/{programStepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/my_program/{programId}/step/{programStepId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __myProgramStep.fromReq = fromReq;
    __myProgramStep.__isAmbassador = true;
    return __myProgramStep;
}
export function myProgramSection(payload) {
    var _a = serializer(_myProgramSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_myProgramSectionResponse, {
        _challengeSection: _challengeSection,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedback: _feedback,
        _feedbackItem: _feedbackItem,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _mediaItems: _mediaItems,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _participantSection: _participantSection,
        _participantSectionStateTransition: _participantSectionStateTransition,
        _participantStep: _participantStep,
        _participantStepStateTransition: _participantStepStateTransition,
        _quantity: _quantity,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _quizSubmission: _quizSubmission,
        _settings: _settings,
        _timeInterval: _timeInterval,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __myProgramSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.participant',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ParticipantsService.MyProgramSection',
            url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                protoPath: '/api/v1/participants/my_program/{programId}/section/{programSectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1ParticipantsServiceUrl({
                        protoPath: '/api/v1/participants/my_program/{programId}/section/{programSectionId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __myProgramSection.fromReq = fromReq;
    __myProgramSection.__isAmbassador = true;
    return __myProgramSection;
}
//# sourceMappingURL=http.impl.js.map